(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contador-apertura"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apertura-countdown')) {
    customElements.define('apertura-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.endAt = Date.parse(this.dataset.endAt);
        this.clock = this.querySelector('[data-clock]');
        this.heading = this.querySelector('[data-heading]');
        this.dateLabel = this.querySelector('[data-date]');
        this.complete = this.querySelector('[data-complete]');
        this.error = this.querySelector('[data-error]');
        this.summary = this.querySelector('[data-summary]');
        this.digits = ['days', 'hours', 'minutes', 'seconds'].map(
          (unit) => this.querySelector('[data-' + unit + ']')
        );

        const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(this.dataset.endAt || '');
        if (!hasTimezone || !Number.isFinite(this.endAt)) {
          this.clock.hidden = true;
          if (this.heading) this.heading.hidden = true;
          if (this.dateLabel) this.dateLabel.hidden = true;
          this.complete.hidden = true;
          this.error.hidden = false;
          if (window.Shopify && window.Shopify.designMode) {
            this.error.textContent = 'Revisa la fecha. Usa el formato 2026-10-09T17:00:00-05:00.';
          }
          return;
        }

        this.error.hidden = true;
        this.onVisibility = () => {
          if (!document.hidden) this.update();
        };

        if (this.update()) {
          this.timer = window.setInterval(() => this.update(), 1000);
          document.addEventListener('visibilitychange', this.onVisibility);
        }
      }

      update() {
        const remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.clock.hidden = true;
          if (this.heading) this.heading.hidden = true;
          if (this.dateLabel) this.dateLabel.hidden = true;
          this.complete.hidden = false;
          this.stop();
          return false;
        }

        const seconds = Math.ceil(remaining / 1000);
        const values = [
          Math.floor(seconds / 86400),
          Math.floor((seconds % 86400) / 3600),
          Math.floor((seconds % 3600) / 60),
          seconds % 60
        ];

        values.forEach((value, index) => {
          const text = String(value).padStart(2, '0');
          if (this.digits[index].textContent !== text) {
            this.digits[index].textContent = text;
          }
        });

        this.summary.textContent = values[0] + ' días, ' + values[1] +
          ' horas, ' + values[2] + ' minutos y ' + values[3] + ' segundos para la apertura.';
        this.clock.hidden = false;
        this.complete.hidden = true;
        if (this.heading) this.heading.hidden = false;
        if (this.dateLabel) this.dateLabel.hidden = false;
        return true;
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
        if (this.onVisibility) {
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dimeloow-scroll-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('dimeloow-story')) return;
  const clamp = (v,lo=0,hi=1) => Math.max(lo,Math.min(hi,v));
  const ease = t => t*t*(3-2*t);
  const mix = (a,b,t) => a+(b-a)*t;
  const number = (v,f=0) => Number.isFinite(Number(v)) ? Number(v) : f;
  function loadViewer(){
    if(customElements.get('model-viewer')) return Promise.resolve();
    if(window.dmlViewerPromise) return window.dmlViewerPromise;
    window.dmlViewerPromise=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.type='module';
      script.src='https://cdnjs.cloudflare.com/ajax/libs/model-viewer/4.1.0/model-viewer.min.js';
      const timeout=setTimeout(()=>reject(new Error('Tiempo de carga del visor agotado')),20000);
      script.onerror=()=>{clearTimeout(timeout);script.remove();reject(new Error('No se pudo cargar el visor'));};
      script.onload=()=>customElements.whenDefined('model-viewer').then(()=>{clearTimeout(timeout);resolve();});
      document.head.append(script);
    }).catch(error=>{window.dmlViewerPromise=null;throw error;});
    return window.dmlViewerPromise;
  }
  class DimeloowStory extends HTMLElement{
    connectedCallback(){
      if(this.controller) return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.scenes=[...this.querySelectorAll('.dml-scene')];
      this.viewer=this.querySelector('model-viewer');
      this.object=this.querySelector('.dml-object');
      this.stage=this.querySelector('.dml-stage');
      this.purchase=this.querySelector('[data-purchase]');
      this.querySelector('[data-purchase-variant]')?.addEventListener('change',event=>{
        const option=event.target.selectedOptions[0];
        if(!option)return;
        this.querySelector('[data-purchase-link]').href=option.dataset.url;
        this.querySelector('[data-purchase-action]').textContent=option.dataset.available==='true'?'Comprar ahora':'Agotado';
      },{signal:this.controller.signal});
      this.scrollProgress=this.querySelector('[data-scroll-progress]');
      this.progressHint=this.querySelector('[data-progress-hint]');
      this.note=this.querySelector('.dml-editor-note');
      this.fixedContent=document.createElement('div');
      this.fixedContent.className='dml-fixed-content';
      this.stage.after(this.fixedContent);
      this.panels=this.scenes.map(scene=>scene.querySelector('.dml-panel'));
      this.panels.forEach((panel,i)=>{
        if(this.scenes[i].dataset.kind!=='hero'||panel.querySelector('.dml-hero-model-space'))return;
        const slot=document.createElement('div');
        slot.className='dml-hero-model-space';slot.setAttribute('aria-hidden','true');panel.append(slot);
      });
      this.screens=this.scenes.map((scene,i)=>{
        const screen=document.createElement('div');
        screen.className=scene.className.replace('dml-scene','dml-screen');
        screen.style.cssText=scene.style.cssText;
        screen.hidden=i!==0;screen.inert=i!==0;
        screen.setAttribute('aria-hidden',String(i!==0));
        screen.append(this.panels[i]);this.fixedContent.append(screen);
        return screen;
      });
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile=matchMedia('(max-width:749px)');
      this.frame=0;
      this.active=-1;
      this.ready=false;
      this.dimensions=null;
      this.schedule=()=>{if(!this.frame&&this.isConnected)this.frame=requestAnimationFrame(()=>this.render());};
      this.measure=()=>{
        this.scrollRoot=null;
        for(let parent=this.parentElement;parent&&parent!==document.body;parent=parent.parentElement){
          if(/auto|scroll/.test(getComputedStyle(parent).overflowY)){this.scrollRoot=parent;break;}
        }
        const head=number(parseFloat(getComputedStyle(this).getPropertyValue('--head')));
        const portHeight=this.scrollRoot?this.scrollRoot.clientHeight:(window.innerHeight||document.documentElement.clientHeight);
        if(portHeight>0)this.style.setProperty('--view',Math.max(1,portHeight-head)+'px');
        const origin=this.getBoundingClientRect().top;
        this.tops=this.scenes.map(scene=>scene.getBoundingClientRect().top-origin);
        this.schedule();
      };
      window.addEventListener('scroll',this.schedule,{passive:true,signal});
      // Scroll does not bubble. Capture scrolls from the theme's internal page wrapper.
      document.addEventListener('scroll',this.schedule,{passive:true,capture:true,signal});
      window.addEventListener('pageshow',this.measure,{signal});
      window.addEventListener('resize',this.measure,{passive:true,signal});
      this.lightPointer={x:0,y:0};
      this.addEventListener('pointermove',event=>{
        if(event.pointerType==='touch'||this.reduced.matches||this.dataset.activeKind!=='finale')return;
        const rect=this.stage.getBoundingClientRect();
        this.lightPointer={x:clamp((event.clientX-rect.left)/Math.max(rect.width,1),0,1)*2-1,y:clamp((event.clientY-rect.top)/Math.max(rect.height,1),0,1)*2-1};
        this.schedule();
      },{passive:true,signal});
      this.addEventListener('pointerleave',()=>{this.lightPointer={x:0,y:0};this.schedule();},{signal});
      this.reduced.addEventListener('change',this.schedule,{signal});
      document.addEventListener('visibilitychange',this.schedule,{signal});
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-ingredient-jump]');
        if(!button||!this.contains(button))return;
        const target=this.scenes.find(scene=>scene.dataset.block===button.dataset.ingredientJump);
        if(!target)return;
        this.goToScene(this.scenes.indexOf(target));
      },{signal});
      this.heroVideos=[...this.querySelectorAll('.dml-bg-video video')];
      document.addEventListener('shopify:block:select',event=>{
        const block=this.querySelector('[data-block="'+event.detail.blockId+'"]')||this.querySelector('[data-sub-block="'+event.detail.blockId+'"]');
        if(!block)return;
        if(block.tagName==='DETAILS')block.open=true;
        const panelIndex=this.panels.findIndex(panel=>panel.contains(block));
        const marker=panelIndex>=0?this.scenes[panelIndex]:block;
        marker.scrollIntoView({block:'start',behavior:'instant'});
        this.schedule();
      },{signal});
      this.measurePurchase=()=>{
        const layer=this.querySelector('.dml-purchase-layer');
        const clearance=this.purchase&&!this.purchase.hidden&&layer
          ? Math.ceil(this.purchase.getBoundingClientRect().height+parseFloat(getComputedStyle(layer).paddingBottom)+14)
          : 20;
        if(this.purchaseClearance!==clearance){
          this.purchaseClearance=clearance;
          this.style.setProperty('--purchase-clearance',clearance+'px');
        }
      };
      this.purchaseObserver=new ResizeObserver(this.measurePurchase);
      if(this.purchase)this.purchaseObserver.observe(this.purchase);
      const purchaseLayer=this.querySelector('.dml-purchase-layer');
      if(purchaseLayer)this.purchaseObserver.observe(purchaseLayer);
      this.measurePurchase();
      this.resizeObserver=new ResizeObserver(this.measure);
      this.resizeObserver.observe(this);
      if(this.closest('.page-wrapper'))this.resizeObserver.observe(this.closest('.page-wrapper'));
      this.scenes.forEach(scene=>this.resizeObserver.observe(scene));
      this.querySelectorAll('.dml-panel').forEach(panel=>this.resizeObserver.observe(panel));
      if(this.viewer){
        this.viewer.addEventListener('load',()=>{
          this.ready=true;
          this.dimensions=this.viewer.getDimensions?.();
          this.center=this.viewer.getCameraTarget?.();
          if(this.note)this.note.hidden=true;
          this.schedule();
        },{signal});
        this.viewer.addEventListener('error',()=>{
          if(this.note){this.note.hidden=false;this.note.textContent='No se pudo cargar el GLB. Revisa la URL y prueba el archivo en la multimedia del producto.';}
        },{signal});
        loadViewer().then(()=>{
          if(signal.aborted)return;
          if(this.viewer.loaded){
            this.ready=true;this.dimensions=this.viewer.getDimensions?.();this.center=this.viewer.getCameraTarget?.();
            if(this.note)this.note.hidden=true;
          }
          this.schedule();
        }).catch(error=>{
          if(!signal.aborted&&this.note){this.note.hidden=false;this.note.textContent=error.message+'. Recarga la vista previa.';}
        });
      }
      this.measure();
      this.setupStepScroll();
    }
    disconnectedCallback(){
      this.purchaseObserver?.disconnect();
      cancelAnimationFrame(this.stepFrame);
      this.stepBusy=false;
      this.querySelectorAll('.dml-bg-video video').forEach(video=>video._dmlDispose?.());
      this.panels?.forEach((panel,i)=>this.scenes[i].append(panel));
      this.fixedContent?.remove();
      this.restoreIngredientLight();this.ingredientLight=null;this.lightPromise=null;this.controller?.abort();this.controller=null;
      this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;
    }

    scenePosition(index){
      const root=this.scrollRoot;
      const head=number(parseFloat(getComputedStyle(this).getPropertyValue('--head')));
      const portTop=root?root.getBoundingClientRect().top+root.clientTop:0;
      const base=(root?root.scrollTop:window.scrollY)+this.getBoundingClientRect().top-portTop-head;
      if(index<0)return Math.max(0,base-this.stage.clientHeight);
      if(index>=this.scenes.length)return base+this.offsetHeight;
      return Math.max(0,base+this.tops[index]+(index===0?0:this.scenes[index].offsetHeight*.27));
    }
    goToScene(index){
      this.measure();
      cancelAnimationFrame(this.stepFrame);
      const root=this.scrollRoot||window;
      const from=this.scrollRoot?root.scrollTop:window.scrollY;
      const to=this.scenePosition(index),start=performance.now();
      this.stepBusy=true;
      const duration=this.reduced.matches?0:650;
      const tick=now=>{
        if(!this.isConnected)return;
        const p=duration?Math.min(1,(now-start)/duration):1;
        root.scrollTo({top:from+(to-from)*(p*p*(3-2*p)),behavior:'instant'});
        this.schedule();
        if(p<1)this.stepFrame=requestAnimationFrame(tick);
        else{this.stepBusy=false;this.stepFinished=performance.now();}
      };
      this.stepFrame=requestAnimationFrame(tick);
    }
    setupStepScroll(){
      if(this.dataset.stepScroll!=='true'||this.dataset.calibrate==='true')return;
      const signal=this.controller.signal;
      this.stepBusy=false;this.wheelLast=0;this.wheelUsed=false;this.wheelSum=0;
      const eligible=target=>{
        if(!this.contains(target)||target.closest('input,select,textarea,button,a,[contenteditable="true"],summary'))return false;
        const rect=this.getBoundingClientRect();
        const top=this.scrollRoot?this.scrollRoot.getBoundingClientRect().top+this.scrollRoot.clientTop:0;
        const head=number(parseFloat(getComputedStyle(this).getPropertyValue('--head')));
        return rect.top<=top+head+2&&rect.bottom>top+head+this.stage.clientHeight*.5;
      };
      const innerCanScroll=(target,dir)=>{
        for(let el=target;el&&el!==this;el=el.parentElement){
          if(!/auto|scroll/.test(getComputedStyle(el).overflowY))continue;
          if(dir>0&&el.scrollTop+el.clientHeight<el.scrollHeight-2)return true;
          if(dir<0&&el.scrollTop>2)return true;
        }
        return false;
      };
      const advance=dir=>{
        this.goToScene((this.activeSceneIndex||0)+dir);
      };
      this.addEventListener('wheel',event=>{
        if(event.ctrlKey||Math.abs(event.deltaX)>Math.abs(event.deltaY)||!event.deltaY)return;
        if(!this.stepBusy&&!eligible(event.target))return;
        const dir=Math.sign(event.deltaY),now=performance.now();
        const gap=now-this.wheelLast;
        this.wheelLast=now;
        if(this.stepBusy){event.preventDefault();this.wheelUsed=true;return;}
        if(gap>280){this.wheelUsed=false;this.wheelSum=0;}
        if(this.wheelUsed){event.preventDefault();return;}
        if(innerCanScroll(event.target,dir))return;
        event.preventDefault();
        const delta=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?this.stage.clientHeight:1);
        if(Math.sign(this.wheelSum)!==dir)this.wheelSum=0;
        this.wheelSum+=delta;
        if(Math.abs(this.wheelSum)>=12){this.wheelUsed=true;advance(dir);}
      },{passive:false,signal});
      this.addEventListener('touchstart',event=>{
        this.stepTouch=event.touches.length===1&&eligible(event.target)?{x:event.touches[0].clientX,y:event.touches[0].clientY,target:event.target,used:false,native:false}:null;
      },{passive:true,signal});
      this.addEventListener('touchmove',event=>{
        const touch=this.stepTouch;
        if(!touch||event.touches.length!==1||touch.native)return;
        const dy=touch.y-event.touches[0].clientY,dx=touch.x-event.touches[0].clientX;
        if(Math.abs(dx)>Math.abs(dy))return;
        if(touch.used||this.stepBusy){event.preventDefault();return;}
        if(Math.abs(dy)<8)return;
        if(innerCanScroll(touch.target,Math.sign(dy))){touch.native=true;return;}
        event.preventDefault();touch.used=true;advance(Math.sign(dy));
      },{passive:false,signal});
      this.addEventListener('touchend',()=>{this.stepTouch=null;},{signal});
      this.addEventListener('touchcancel',()=>{this.stepTouch=null;},{signal});
      document.addEventListener('keydown',event=>{
        if(event.altKey||event.ctrlKey||event.metaKey)return;
        const dir=event.key==='ArrowDown'||event.key==='PageDown'||event.key===' '&&!event.shiftKey?1:event.key==='ArrowUp'||event.key==='PageUp'||event.key===' '&&event.shiftKey?-1:0;
        const target=event.target===document.body?this:event.target;
        if(!dir||!eligible(target)||innerCanScroll(target,dir))return;
        event.preventDefault();if(!event.repeat&&!this.stepBusy)advance(dir);
      },{signal});
    }
    async prepareIngredientLight(){
      if(this.lightPromise||!this.viewer?.model)return;
      const signal=this.controller.signal;
      this.lightPromise=(async()=>{
        const materials=this.viewer.model.materials;
        const material=materials.find(m=>m.name===this.dataset.labelMaterial)||materials.find(m=>m.pbrMetallicRoughness.baseColorTexture.texture);
        if(!material)throw new Error('No se encontró el material de la etiqueta');
        const response=await fetch(this.dataset.modelUrl,{signal});
        if(!response.ok)throw new Error('No se pudo leer la textura del GLB');
        const bytes=await response.arrayBuffer(),view=new DataView(bytes);
        if(view.getUint32(0,true)!==0x46546c67)throw new Error('La iluminación necesita un archivo GLB');
        let json,bin;
        for(let offset=12;offset+8<=bytes.byteLength;){
          const length=view.getUint32(offset,true),type=view.getUint32(offset+4,true);offset+=8;
          if(type===0x4e4f534a)json=JSON.parse(new TextDecoder().decode(bytes.slice(offset,offset+length)));
          if(type===0x004e4942)bin=bytes.slice(offset,offset+length);
          offset+=length;
        }
        const definition=json.materials.find(m=>m.name===material.name)||json.materials[materials.indexOf(material)];
        const texture=json.textures[definition.pbrMetallicRoughness.baseColorTexture.index];
        const source=json.images[texture.source];let url,owned=false;
        if(source.bufferView!==undefined){
          const buffer=json.bufferViews[source.bufferView];
          url=URL.createObjectURL(new Blob([bin.slice(buffer.byteOffset||0,(buffer.byteOffset||0)+buffer.byteLength)],{type:source.mimeType}));owned=true;
        }else url=new URL(source.uri,this.dataset.modelUrl).href;
        const image=new Image();image.crossOrigin='anonymous';
        try{image.src=url;await image.decode();}finally{if(owned)URL.revokeObjectURL(url);}
        if(signal.aborted)return;
        const canvasTexture=this.viewer.createCanvasTexture();
        const canvas=canvasTexture.source.element;
        canvas.width=Math.min(1536,image.naturalWidth);canvas.height=Math.round(canvas.width*image.naturalHeight/image.naturalWidth);
        this.ingredientLight={material,texture:canvasTexture,canvas,image,original:material.pbrMetallicRoughness.baseColorTexture.texture,
          metals:materials.filter(m=>m!==material).map(m=>({pbr:m.pbrMetallicRoughness,color:[...m.pbrMetallicRoughness.baseColorFactor]})),applied:false};
        this.schedule();
      })().catch(error=>{
        if(signal.aborted)return;
        if(this.note){this.note.hidden=false;this.note.textContent='Iluminación de ingredientes: '+error.message+'. La lata conserva su material original.';}
        console.warn('DIMELOOW: iluminación de ingredientes no disponible',error);
      });
    }
    restoreIngredientLight(){
      const light=this.ingredientLight;if(!light?.applied)return;
      light.material.pbrMetallicRoughness.baseColorTexture.setTexture(light.original);
      light.metals.forEach(m=>m.pbr.setBaseColorFactor(m.color));light.applied=false;light.key=null;
    }
    drawIngredientLight(scene,previous,t){
      const on=scene.dataset.kind==='benefit',was=previous.dataset.kind==='benefit';
      if(!on&&!was){this.restoreIngredientLight();return;}
      const light=this.ingredientLight;if(!light){this.prepareIngredientLight();return;}
      const strength=on?(was?1:t):1-t;
      if(strength<=0){this.restoreIngredientLight();return;}
      const params=d=>({x:number(d.lightX,86),y:number(d.lightY,49),w:number(d.lightWidth,26),h:number(d.lightHeight,16),soft:number(d.lightSoftness,45),dark:number(d.lightDarkness,96)});
      const a=params((was?previous:scene).dataset),b=params((on?scene:previous).dataset),p={};
      Object.keys(a).forEach(k=>p[k]=mix(a[k],b[k],t));
      const key=JSON.stringify([p,strength]);if(key===light.key)return;light.key=key;
      const {canvas,image}=light,w=canvas.width,h=canvas.height,ctx=canvas.getContext('2d');
      ctx.clearRect(0,0,w,h);
      // Canvas textures use the opposite vertical orientation to the embedded GLB image.
      // Flip the whole composition, including its mask, so editor coordinates stay top-down.
      ctx.save();ctx.translate(0,h);ctx.scale(1,-1);
      ctx.drawImage(image,0,0,w,h);
      // The mask is in texture coordinates, so it follows the actual UV mapping.
      const rx=Math.max(1,p.w*w/200),ry=Math.max(1,p.h*h/200);
      ctx.save();ctx.translate(p.x*w/100,p.y*h/100);ctx.scale(rx,ry);
      const gradient=ctx.createRadialGradient(0,0,0,0,0,1);
      gradient.addColorStop(0,'rgba(0,0,0,0)');gradient.addColorStop(clamp(1-p.soft/100,0,.99),'rgba(0,0,0,0)');gradient.addColorStop(1,'rgba(0,0,0,'+(p.dark/100*strength)+')');
      ctx.fillStyle=gradient;ctx.fillRect(-w/rx,-h/ry,2*w/rx,2*h/ry);ctx.restore();
      ctx.restore();
      light.texture.source.update();
      if(!light.applied){light.material.pbrMetallicRoughness.baseColorTexture.setTexture(light.texture);light.applied=true;}
      light.metals.forEach(m=>m.pbr.setBaseColorFactor(m.color.map((v,i)=>i<3?v*(1-.92*strength):v)));
    }

    state(scene){
      const d=scene.dataset;
      const side=scene.classList.contains('dml-right')?-1:1;
      return {angle:number(d.angle)+number(d.faceOffset),offsetX:number(d.positionX),offsetY:number(d.positionY),scale:number(d.modelScale,100)/100,mobileX:number(d.mobileX),mobileY:number(d.mobileY),mobileScale:number(d.sceneMobileScale,100)/100,pitch:number(d.pitch,80),zoom:number(d.zoom,100),
        target:number(d.target),tilt:d.kind==='flavor'?number(d.flavorTilt,-20):number(d.tilt),x:d.kind==='finale'?0:d.kind==='hero'?3:((d.kind==='flavor'||d.kind==='benefit')?5:side*24),y:0};
    }
    render(){
      this.frame=0;
      if(!this.scenes.length)return;
      const view=this.stage.clientHeight;
      const head=number(parseFloat(getComputedStyle(this).getPropertyValue('--head')));
      const portTop=this.scrollRoot?this.scrollRoot.getBoundingClientRect().top+this.scrollRoot.clientTop:0;
      const y=Math.max(0,portTop-this.getBoundingClientRect().top+head);
      let index=0;
      this.tops.forEach((top,i)=>{if(y>=top)index=i;});
      this.activeSceneIndex=index;
      const scene=this.scenes[index];
      const previous=this.scenes[Math.max(0,index-1)];
      const height=scene.offsetHeight;
      const p=clamp((y-this.tops[index])/Math.max(height,1));
      const calibrating=this.dataset.calibrate==='true';
      const t=this.reduced.matches||calibrating?1:ease(clamp(p/.25));
      const a=this.state(previous), b=this.state(scene);
      if(index>0&&previous.dataset.kind==='hero'&&!calibrating&&!this.reduced.matches)a.angle+=number(previous.dataset.heroSpin,180);
      const state={};
      Object.keys(b).forEach(key=>state[key]=mix(a[key],b[key],t));
      if(scene.dataset.kind==='hero'&&!calibrating&&!this.reduced.matches)state.angle+=number(scene.dataset.heroSpin,180)*ease(p);
      if(this.ready)this.drawIngredientLight(scene,previous,t);
      this.screens.forEach((screen,i)=>{
        const active=i===index;
        screen.hidden=!active;screen.inert=!active;screen.setAttribute('aria-hidden',String(!active));
      });
      this.dataset.activeKind=scene.dataset.kind;
      if(this.purchase)this.purchase.hidden=index<1;
      this.measurePurchase?.();
      (this.heroVideos||[]).forEach(video=>{
        // Playback begins natively, independently of scroll and model loading.
        const shouldPlay=scene.dataset.kind==='hero'&&video.parentElement.parentElement.dataset.heroBg===scene.dataset.block;
        const changed=video._dmlShouldPlay!==shouldPlay;
        video._dmlShouldPlay=shouldPlay;
        if(!shouldPlay){if(!video.paused)video.pause();}
        else if(changed)video._dmlRestart?.();
      });
      this.querySelectorAll('[data-hero-bg]').forEach(layer=>{
        layer.style.opacity=layer.dataset.heroBg===scene.dataset.block?'1':(layer.dataset.heroBg===previous.dataset.block?String(1-t):'0');
      });
      this.querySelectorAll('[data-flavor-bg]').forEach(layer=>{
        layer.style.opacity=layer.dataset.flavorBg===scene.dataset.block?String(t):(layer.dataset.flavorBg===previous.dataset.block?String(1-t):'0');
      });
      this.querySelectorAll('[data-finale-bg]').forEach(layer=>{
        const isCurrent=layer.dataset.finaleBg===scene.dataset.block;
        const wasPrevious=layer.dataset.finaleBg===previous.dataset.block;
        const opacity=isCurrent?(index===0?1:t):wasPrevious?1-t:0;
        layer.style.opacity=String(opacity);layer.classList.toggle('is-running',opacity>0);
        if(opacity>0){
          const depth=this.reduced.matches?0:number(layer.dataset.depth,25);
          layer.style.setProperty('--px',(this.lightPointer.x*depth)+'px');
          layer.style.setProperty('--py',(this.lightPointer.y*depth)+'px');
          layer.style.setProperty('--scroll-light',((p-.5)*2*depth)+'px');
        }
      });
      const bg=scene.dataset.bg;
      this.style.setProperty('--tone',bg);
      const progress=clamp(y/Math.max(this.offsetHeight-view,1));
      this.style.setProperty('--progress',progress);
      if(this.scrollProgress){
        const percent=Math.round(progress*100);
        this.scrollProgress.setAttribute('aria-valuenow',String(percent));
        const complete=progress>=.995;
        this.dataset.progressComplete=String(complete);
        if(this.progressHint){
          this.progressHint.parentElement.hidden=index<1||scene.dataset.kind==='hero';
          this.progressHint.textContent=complete?'Recorrido completo':'Sigue deslizando';
        }
      }
      this.querySelector('.dml-status').textContent='DIMELOOW / '+String(index+1).padStart(2,'0')+' — '+String(this.scenes.length).padStart(2,'0');
      if(this.object){
        const small=this.mobile.matches;
        const baseScale=small?number(this.dataset.mobileScale,90)/100*(scene.dataset.kind==='hero'?Math.min(.66,340/Math.max(view,1)):(scene.dataset.kind==='finale'?.72:.50)):(scene.dataset.kind==='hero'?.96:1);
        let scale=baseScale*(small?state.mobileScale:state.scale);
        const x=small?state.mobileX:state.x+state.offsetX;
        let ty=small?(scene.dataset.kind==='finale'?0:-23):state.y;
        let unit='svh';
        if(small&&scene.dataset.kind==='hero'){
          const slot=this.panels[index].querySelector('.dml-hero-model-space').getBoundingClientRect();
          const stageRect=this.stage.getBoundingClientRect();
          // Anchor to the actual mobile grid cell, including when the sticky layer releases.
          ty=slot.top+slot.height/2-stageRect.top-view/2;unit='px';
          const available=Math.max(1,Math.min(slot.height-16,this.stage.clientWidth*.85));
          scale=number(this.dataset.mobileScale,90)/100*Math.min(.66,available/Math.max(view,1))*state.mobileScale;
        }
        const offsetY=(small?state.mobileY:state.offsetY)*view/100;
        const xPixels=x*this.stage.clientWidth/100;
        const yPixels=(unit==='px'?ty:ty*view/100)+offsetY;
        this.object.style.transform='translate('+xPixels+'px,'+yPixels+'px) rotate('+state.tilt+'deg) scale('+scale+')';
      }
      const angle=number(this.dataset.baseAngle)+state.angle;
      if(this.viewer&&this.ready){
        // Compensate for the larger render surface; merchant zoom remains relative.
        this.viewer.setAttribute('camera-orbit',angle+'deg '+state.pitch+'deg '+(state.zoom*2.3)+'%');
        if(this.dimensions&&this.center){
          const cy=this.center.y+(state.target/100)*this.dimensions.y;
          this.viewer.setAttribute('camera-target',this.center.x+'m '+cy+'m '+this.center.z+'m');
        }
      }
      this.scenes.forEach((s,i)=>{
        const visible=Math.abs(i-index)<=1;
        const cross=s.dataset.kind==='exclude';
        if(cross){
          const sp=clamp((y-this.tops[i])/Math.max(s.offsetHeight,1));
          const at=number(s.dataset.strike,40)/100;
          const strike=this.reduced.matches?1:ease(clamp((sp-at)/.12));
          this.screens[i].style.setProperty('--strike',strike);
          this.screens[i].classList.toggle('is-struck',strike>.5);
        }
        // Keep content in document flow and focusable throughout the story.
        if(visible&&s.dataset.kind==='moments'){
          const items=[...this.panels[i].querySelectorAll('.dml-moment')];
          const mi=Math.min(items.length-1,Math.floor(p*items.length));
          items.forEach((item,j)=>item.classList.toggle('is-current',j===mi));
        }
      });
      if(index!==this.active){
        this.active=index;
        if(scene.dataset.kind==='nutrition'&&!scene.dataset.counted){
          scene.dataset.counted='true';
          this.panels[index].querySelectorAll('.dml-count').forEach(el=>{
            const end=Number(el.dataset.value);
            if(!Number.isFinite(end)||this.reduced.matches)return;
            const decimals=(el.dataset.value.split('.')[1]||'').length;
            const start=performance.now();
            const tick=now=>{
              if(!this.isConnected)return;
              const f=clamp((now-start)/800);
              el.textContent=(end*ease(f)).toLocaleString('es-CO',{minimumFractionDigits:decimals,maximumFractionDigits:decimals});
              if(f<1)requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          });
        }
      }
      const out=this.querySelector('.dml-calibration');
      if(out)out.textContent='Escena '+(index+1)+' · giro '+angle.toFixed(0)+'° · altura '+state.target.toFixed(0)+'% · distancia '+state.zoom.toFixed(0)+'%';
    }
  }
  customElements.define('dimeloow-story',DimeloowStory);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
